import { useEffect, useRef } from 'react'

// Aviso quando a entrega muda de etapa: um som curto (gerado aqui, sem
// arquivo), o título da aba e uma vibração no celular.
//   - Chegou ao destino: laço de seda + pop + brilho de sino.
//   - Entregue: o mesmo, fechando num acorde que sobe com faísca.
// Só toca na TROCA de etapa vista nesta aba (abrir já entregue não toca).
// Navegador só deixa tocar depois de um clique na página: o contexto de áudio
// é destravado no primeiro toque/clique.

let contexto = null
// Só toca depois de um toque/clique real na página (senão o navegador segura
// o som e toca tudo junto no primeiro toque, minutos depois).
let destravado = false
let dormir = null
const audio = () => {
  const Ctx = window.AudioContext || window.webkitAudioContext
  if (!Ctx) return null
  if (!contexto) contexto = new Ctx()
  return contexto
}
// Contexto ligado gasta bateria no celular: dorme uns segundos depois de usar.
const adormecer = () => {
  clearTimeout(dormir)
  dormir = setTimeout(() => contexto?.suspend?.().catch(() => {}), 4000)
}
export const destravar = () => {
  destravado = true
  const ctx = audio()
  if (!ctx) return
  ctx.resume?.().catch(() => {})
  // iPhone: só libera de vez tocando alguma coisa DENTRO do gesto — um
  // instante de silêncio basta.
  try {
    const fonte = ctx.createBufferSource()
    fonte.buffer = ctx.createBuffer(1, 1, 22050)
    fonte.connect(ctx.destination)
    fonte.start(0)
  } catch (e) {
    // sem áudio: segue
  }
  adormecer()
}

// Som da beuni (escolhido pelo Murilo em 28/09/2026, "B2 · Laço de seda"):
// puxada de laço longa e macia + "pop" suave da tampa + brilho de sino. No
// "entregue", o brilho vira um acorde que sobe com faísca. Tudo sintetizado
// aqui: sem arquivo, sem licença.
const NOTAS = { C6: 1046.5, E6: 1318.51, G6: 1567.98, C7: 2093 }

// Saída com um eco curto (dá corpo sem arquivo de reverb).
const saida = (ctx) => {
  const g = ctx.createGain()
  g.gain.value = 0.9
  const atraso = ctx.createDelay()
  atraso.delayTime.value = 0.13
  const volta = ctx.createGain()
  volta.gain.value = 0.2
  const filtro = ctx.createBiquadFilter()
  filtro.type = 'lowpass'
  filtro.frequency.value = 5000
  g.connect(ctx.destination)
  g.connect(atraso)
  atraso.connect(volta)
  volta.connect(filtro)
  filtro.connect(atraso)
  filtro.connect(ctx.destination)
  return [g, atraso, volta, filtro]
}

// Sino: ataque rápido, queda suave e um harmônico baixinho.
const sino = (ctx, out, freq, inicio, duracao, volume, tipo = 'triangle') => {
  const osc = ctx.createOscillator()
  const harm = ctx.createOscillator()
  const ganho = ctx.createGain()
  const ganhoHarm = ctx.createGain()
  osc.type = tipo
  osc.frequency.value = freq
  harm.type = 'sine'
  harm.frequency.value = freq * 2.01
  ganhoHarm.gain.value = 0.25
  ganho.gain.setValueAtTime(0.0001, inicio)
  ganho.gain.exponentialRampToValueAtTime(volume, inicio + 0.01)
  ganho.gain.exponentialRampToValueAtTime(0.0001, inicio + duracao)
  osc.connect(ganho)
  harm.connect(ganhoHarm).connect(ganho)
  ganho.connect(out)
  osc.start(inicio)
  harm.start(inicio)
  osc.stop(inicio + duracao + 0.05)
  harm.stop(inicio + duracao + 0.05)
}

// Laço de seda sendo puxado: ruído filtrado que sobe devagar.
const laco = (ctx, out, inicio, duracao) => {
  const n = Math.floor(ctx.sampleRate * duracao)
  const buffer = ctx.createBuffer(1, n, ctx.sampleRate)
  const dados = buffer.getChannelData(0)
  for (let i = 0; i < n; i++) dados[i] = Math.random() * 2 - 1
  const fonte = ctx.createBufferSource()
  fonte.buffer = buffer
  const filtro = ctx.createBiquadFilter()
  filtro.type = 'bandpass'
  filtro.Q.value = 1.2
  filtro.frequency.setValueAtTime(700, inicio)
  filtro.frequency.exponentialRampToValueAtTime(5500, inicio + duracao)
  const ganho = ctx.createGain()
  ganho.gain.setValueAtTime(0.0001, inicio)
  ganho.gain.exponentialRampToValueAtTime(0.07, inicio + duracao * 0.4)
  ganho.gain.exponentialRampToValueAtTime(0.0001, inicio + duracao)
  fonte.connect(filtro).connect(ganho).connect(out)
  fonte.start(inicio)
  fonte.stop(inicio + duracao)
}

// "Pop" suave da tampa: tom que cai rápido.
const pop = (ctx, out, inicio) => {
  const osc = ctx.createOscillator()
  const ganho = ctx.createGain()
  osc.type = 'sine'
  osc.frequency.setValueAtTime(600, inicio)
  osc.frequency.exponentialRampToValueAtTime(160, inicio + 0.1)
  ganho.gain.setValueAtTime(0.0001, inicio)
  ganho.gain.exponentialRampToValueAtTime(0.22, inicio + 0.006)
  ganho.gain.exponentialRampToValueAtTime(0.0001, inicio + 0.13)
  osc.connect(ganho).connect(out)
  osc.start(inicio)
  osc.stop(inicio + 0.15)
}

export const tocar = (tipo) => {
  const ctx = audio()
  if (!ctx || !destravado) return
  // Sempre pede resume: um suspend ainda pendente (o "dormir") seria
  // atendido depois das notas e o som sairia só no próximo aviso.
  clearTimeout(dormir)
  Promise.resolve(ctx.resume())
    .then(() => {
      if (ctx.state === 'running') tocarAgora(ctx, tipo)
    })
    .catch(() => {})
}

const tocarAgora = (ctx, tipo) => {
  const nos = saida(ctx)
  const out = nos[0]
  // O eco fica num laço fechado: solta tudo depois que o som acabou.
  setTimeout(() => nos.forEach((n) => n.disconnect()), 3500)
  adormecer()
  const t = ctx.currentTime + 0.03
  // "Plim" curto e baixo que chama o motorista pro arrastar: só o sino.
  if (tipo === 'chamada') {
    ;[NOTAS.G6, NOTAS.C7].forEach((f, i) => sino(ctx, out, f, t + i * 0.09, 0.7, 0.05))
    return
  }
  laco(ctx, out, t, 0.5)
  pop(ctx, out, t + 0.5)
  const notas = tipo === 'entregue' ? [NOTAS.C6, NOTAS.E6, NOTAS.G6, NOTAS.C7] : [NOTAS.E6, NOTAS.G6]
  notas.forEach((f, i) => sino(ctx, out, f, t + 0.58 + i * 0.06, 1.3, 0.09))
  if (tipo === 'entregue') [NOTAS.E6 * 2, NOTAS.G6 * 2].forEach((f, i) => sino(ctx, out, f, t + 0.95 + i * 0.07, 0.6, 0.035, 'sine'))
}

const TITULO = { arriving: '🔔 Chegou!', delivered: '✅ Entregue!' }

export default function useSomDaEntrega(status, rotulo) {
  const anterior = useRef(status)
  const tituloOriginal = useRef(document.title)
  const volta = useRef(null)
  // Título de aviso volta ao normal 8s depois de a pessoa estar vendo a aba.
  const voltarTitulo = () => {
    clearTimeout(volta.current)
    volta.current = setTimeout(() => {
      document.title = tituloOriginal.current
    }, 8000)
  }

  // Destrava o áudio no primeiro toque/clique na página (regra dos
  // navegadores; o iPhone às vezes só libera no touchend/click).
  useEffect(() => {
    const eventos = ['pointerdown', 'touchend', 'click', 'keydown']
    eventos.forEach((e) => window.addEventListener(e, destravar, { once: true }))
    return () => eventos.forEach((e) => window.removeEventListener(e, destravar))
  }, [])

  useEffect(() => {
    const de = anterior.current
    anterior.current = status
    if (!de || de === status || !TITULO[status]) return
    tocar(status === 'arriving' ? 'chegou' : 'entregue')
    try {
      navigator.vibrate?.(status === 'arriving' ? [120, 80, 120] : [200])
    } catch (e) {
      // sem vibração: segue
    }
    document.title = `${TITULO[status]} · ${rotulo || 'Entrega'}`
    if (!document.hidden) voltarTitulo()
  }, [status, rotulo])

  // O título avisa quem está em outra aba; quando a pessoa volta e vê, ele
  // volta ao normal em alguns segundos. E ao sair da tela.
  useEffect(() => {
    const original = tituloOriginal.current
    const aoVoltar = () => {
      if (document.hidden || document.title === original) return
      voltarTitulo()
    }
    document.addEventListener('visibilitychange', aoVoltar)
    return () => {
      clearTimeout(volta.current)
      document.removeEventListener('visibilitychange', aoVoltar)
      document.title = original
    }
  }, [])
}
